<template>
  <div class="app-container">
    <div class="navbar-group">
      <el-button type="primary" @click.native="RestartOrder" :disabled="!canWrite">新增</el-button>
      <el-button type="primary" @click.native="toggleOrder" :disabled="data.Status == 3 || !canWrite">单据选择</el-button>
      <el-button type="primary" @click.native="save" :disabled="(data.Status == 3 && !is_orderUpdateStatus) || !canWrite">保存</el-button>
      <el-button type="primary" @click.native="orderUpdate" :disabled="data.Status != 3 || !canWrite">变更</el-button>
      <el-button type="primary" @click.native="orderDel" :disabled="!isSave || data.Status == 3 || !canWrite">删除</el-button>
      <el-button type="primary" @click.native="orderReview" :disabled="!isSave || !canReview">{{ ReviewName }}</el-button>
      <!-- 联查 -->
      <el-dropdown>
        <el-button type="primary" :disabled="!isSave"> 联查<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
        <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
          <el-dropdown-item class="dropdown-item" @click.native="goJump(1)">报价单</el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="goJump(2)">销货单</el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="goJump(3)">采购订单</el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="goJump(4)">请购单</el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="goJump(5)">销售出库单</el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="goJump(6)">收款单</el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="goJump(7)">采购需求分析情况</el-dropdown-item>
          <!-- <el-dropdown-item class="dropdown-item">配货情况</el-dropdown-item> -->
          <el-dropdown-item class="dropdown-item" @click.native="goJump(8)">生产加工情况</el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="goJump(9)">委托加工情况</el-dropdown-item>
          <!-- <el-dropdown-item class="dropdown-item"
            >订单追踪工具</el-dropdown-item
          >
          <el-dropdown-item class="dropdown-item">订单执行图</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" @click="onPrint(data)" :disabled="!isSave">打印</el-button>
      <el-button type="primary" @click="openSetField">明细字段</el-button>
    </div>
    <el-form :inline="true" :model="data" :line-form="true" label-width="90px" ref="ruleForm" :rules="rules" status-icon>
      <el-row>
        <!-- 单据日期 -->
        <el-form-item label="单据日期:" prop="OrderDate">
          <span class="not-edit" v-if="ReviewStatus">{{ $commonJs.toDateString(data.OrderDate) }}</span>
          <el-date-picker
            v-else
            v-model="data.OrderDate"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 180px"
            :clearable="false"
            @change="val => previewNo(val)"
          />
        </el-form-item>
        <el-form-item label="单据编码:" prop="OrderNo">
          <template v-if="UseClassCode">
            <span v-if="Mode == 0 || ReviewStatus" class="not-edit" style="min-width: 180px">{{ data.OrderNo ? data.OrderNo : '请先选择客户' }}</span>
            <el-input v-else v-model="data.OrderNo" placeholder="请输入单据编码" />
          </template>
          <template v-else>
            <span v-if="Mode == 0 || ReviewStatus" class="not-edit" style="min-width: 180px">{{ data.OrderNo }}</span>
            <el-input v-else v-model="data.OrderNo" placeholder="请输入单据编码" />
          </template>
        </el-form-item>
        <el-form-item label="客户:" prop="TradeUnitId">
          <span class="not-edit" v-if="ReviewStatus">{{ data.FullName }}</span>
          <!-- <select-input
            v-else
            placeholder="请选择客户"  
            :label="data.FullName"
            v-model="data.TradeUnitId"
            @click="openTradeunit"
            :clearable="!isSelect"
            :disabled="isSelect"
          /> -->
          <el-select v-else v-model="data.TradeUnitId" :disabled="isSelect" filterable style="width: 180px">
            <div style="max-height: 274px; overflow: scroll; margin-bottom: -17px; margin-right: -17px">
              <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :value="item.TradeUnitId" :label="item.FullName" @click.native="setTradeunit(item)"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="运输方式:" prop="TransportId">
          <span class="not-edit" v-if="ReviewStatus">{{ data.TransportName }}</span>
          <el-select v-else v-model="data.TransportId" style="width: 180px">
            <el-option v-for="item in transportList" :key="item.TransportId" :value="item.TransportId" :label="item.TransportName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否布产:">
          <span class="not-edit" v-if="ReviewStatus">{{ data.IsCloth == true ? '是' : data.IsCloth == false ? '否' : '' }}</span>
          <el-select v-else v-model="data.IsCloth" style="width: 180px" @change="changeIsCloth">
            <el-option
              v-for="item in [
                { label: '是', value: true },
                { label: '否', value: false }
              ]"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 经手人 -->
        <el-form-item label="经手人:" prop="EmpId">
          <span class="not-edit" v-if="ReviewStatus">{{ data.EmpName }}</span>
          <select-input v-else placeholder="请选择经办人" :label="data.EmpName" v-model="data.EmpId" @click="openEmp" style="width: 180px" />
        </el-form-item>
        <el-form-item label="金额汇总:">
          {{ tableAmountSum }}
        </el-form-item>
        <!-- 制单人 -->
        <el-form-item label="制单人:">
          {{ data.MakeEmpName }}
        </el-form-item>
        <el-col :span="24">
          <el-form-item label="送货地址:">
            <span class="not-edit" v-if="ReviewStatus">{{ data.Address }}</span>
            <el-input v-else type="textarea" v-model="data.Address" maxlength="60" placeholder="请填写地址" :autosize="{ minRows: 1, maxRows: 2 }" style="width: 460px" />
          </el-form-item>
        </el-col>
      </el-row>
      <!--  -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注:">
            <span v-if="orderUpdateStatus">{{ data.Remark }}</span>
            <el-input v-else type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" style="width: 600px" />
          </el-form-item>
        </el-col>
      </el-row>
      <!--  -->
      <el-row style="margin: 0px 0 20px">
        <el-table border max-height="450" :data="tableList" class="tableList" :row-class-name="tableRowClassName" @row-click="addColumn" v-keymove="addList" :summary-method="summaryFunc" show-summary>
          <insert-row @on-insert="onInsert" />
          <!-- <el-table-column align="center" label="条形码" min-width="140px">
            <template slot-scope="{ row }">
              <vue-barcode
                :value="row.ProductNo"
                width="1"
                height="20"
                fontSize="10"
              ></vue-barcode>
            </template>
          </el-table-column> -->
          <el-table-column min-width="160" align="left" label="备注" v-if="showField('备注')">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{ row.Remark }}</span>
              <el-input v-else v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
            </template>
          </el-table-column>
          <el-table-column align="left" label="存货名称" min-width="120px" v-if="showField('存货名称')">
            <template slot-scope="{ row, $index }">
              <span v-if="!data.TradeUnitId" style="color: #999">请先选择客户</span>
              <span v-else-if="ReviewStatus">{{ row.ProductName }}</span>
              <account-select
                v-else
                v-model="row.ProductName"
                :source="DAccount"
                @select="onSelect($event, row, $index)"
                :pageSize="pageParams.pageSize"
                :pageIndex="pageParams.pageIndex"
                :listTotal="listTotal"
                @inputText="inputText"
                @click.native="resetFun"
                @currentPage="currentPage"
                :pageType="true"
              />
            </template>
          </el-table-column>
          <el-table-column align="left" label="存货编码" min-width="120px" v-if="showField('存货编码')">
            <template slot-scope="{ row }">
              <span>{{ row.ProductNo }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="规格型号" v-if="showField('规格型号')" min-width="120px">
            <template slot-scope="{ row }">
              <span>{{ row.ProductSpec }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="left" label="批号" v-if="showField('批号')">
            <template slot-scope="{ row }">
              <span v-if="!row.IsBatchNumber" class="text-gray">该存货未启用批号</span>
              <template v-else>
                <span v-if="ReviewStatus">{{ row.BatchNumber }}</span>
                <el-input v-else v-model="row.BatchNumber" @change="editT(row)" placeholder="请输入批号" />
              </template>
            </template>
          </el-table-column>
          <el-table-column align="left" label="属性" v-if="showField('属性')" min-width="150px">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.PropertyName }}</span>
              <!-- <account-select
                v-else-if="row.UseProcess"
                v-model="row.PropertyName"
                :source="PropertyAccount"
                :Head="PropertyHead"
                @select="onPropertySelect($event, row,$index)"
                :pageSize="pagePropertyParams.pageSize"
                :pageIndex="pagePropertyParams.pageIndex"
                :listTotal="listPropertyTotal"
                @inputText="inputPropertyText"
                @click.native="resetPropertyFun(row)"
                @currentPage="currentPropertyPage($event, row)"
                :pageType="true"
                keyword="PropertyName"
              /> -->
              <el-select filterable v-else-if="row.UseProcess && !ReviewStatus" v-model="row.PropertyId" @change="changeProperty($event, row, $index)">
                <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName" :disabled="item.Status == 0" />
              </el-select>
              <span v-else>{{ row.PropertyName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="颜色" min-width="100px" v-if="showField('颜色')">
            <template slot-scope="{ row, $index }">
              <span v-if="row.SourceNo && !row.ColorId">{{ row.ColorName || '' }}</span>
              <el-select filterable v-else-if="row.UseColor && !ReviewStatus" v-model="row.ColorId" @change="changeColor($event, row, $index)" :filter-method="filterSelectMethod">
                <el-option v-for="item in options" :key="item.ColorId" :value="item.ColorId" :label="item.ColorName" :disabled="item.Status == 0">
                  <span class="option-span">{{ item.ColorNo }}</span>
                  <span class="option-span">{{ item.ColorName }}</span>
                </el-option>
              </el-select>
              <span v-else>{{ row.ColorName || '' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="存货条码" prop="BarCode" align="left" min-width="160" v-if="showField('存货条码')"> </el-table-column>
          <el-table-column align="left" label="销售单位" min-width="90px" v-if="showField('销售单位')">
            <template slot-scope="{ row, $index }">
              <el-select v-if="row.Units && row.Units.length > 0 && !ReviewStatus && row.HasGrammage != true" v-model="row.SaUnitId">
                <el-option v-for="item in row.Units" :key="item.UnitName" :value="item.UnitId" :label="item.UnitName" @click.native="compareSaUnit(item, row, $index)"></el-option>
              </el-select>
              <span v-else>{{ row.SaUnitName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="right" label="数量" min-width="80px" prop="SaQuantity" v-if="showField('数量')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.SaQuantity) }}</span>
              <el-input v-else v-quantity:[option]="option" type="text" v-model="row.SaQuantity" @change="changeQuantity($event, row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="left" label="计量单位2" min-width="80px" v-if="showField('计量单位2')">
            <template slot-scope="{ row, $index }">
              <!-- <span>{{ row }}{{ $index }}</span> -->
              <el-select v-if="row.Units && row.Units.length > 0 && !ReviewStatus && row.HasGrammage != true" v-model="row.UnitId2">
                <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareUnitId(item, row, $index)"></el-option>
              </el-select>
              <span v-else-if="row.UnitType == 0"></span>
              <span v-else>{{ row.UnitName2 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="数量2" min-width="80px" prop="Quantity2" v-if="showField('数量2')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.Quantity2) }}</span>
              <span v-else-if="row.UnitType == 0"></span>
              <el-input
                v-else
                v-quantity:[option]="option"
                type="text"
                v-model="row.Quantity2"
                @change="changeQuantity2($event, row, $index)"
                @blur="getChangeQuantity($event, row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="换算率" v-if="showField('换算率')">
            <template slot-scope="{ row, $index }">
              <span v-if="(ReviewStatus || row.ChangeType == 0) && row.UnitType == 1">{{ row.Rate }}</span>
              <span v-else-if="row.UnitType == 0"></span>
              <el-input v-else type="text" v-model="row.Rate" @input="RateChange($event, row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="最新含税进价" min-width="90px" v-if="canPrice && showField('最新含税进价')">
            <template slot-scope="{ row }">
              <span>{{ row.PurchasePrice }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="最新含税售价" min-width="90px" v-if="canPrice && showField('最新含税售价')">
            <template slot-scope="{ row }">
              <span>{{ row.SalePrice }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="最低售价" v-if="canPrice && showField('最低售价')">
            <template slot-scope="{ row }">
              <span>{{ row.RetailPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="报价" min-width="90px" v-if="canPrice && showField('报价')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.QuotedPrice }}</span>
              <el-input v-else v-price type="text" v-model="row.QuotedPrice" :disabled="row.IsGift" @input="changeQuotedPrice(row, $index)"> </el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="折扣%" min-width="90px" v-if="canPrice && showField('折扣%')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Discount }}</span>
              <el-input v-else v-decimals type="text" v-model="row.Discount" :disabled="row.IsGift" @input="changeDiscount(row, $index)" />
            </template>
          </el-table-column>
          <el-table-column align="right" label="税率%" min-width="90px" v-if="canPrice && showField('税率%')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.TaxRate }}</span>
              <el-input v-else v-decimals v-limit:value="{ max: 100, min: 0 }" type="text" v-model.number="row.TaxRate" :disabled="row.IsGift" @input="changeTaxRate(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="单价" min-width="110px" v-if="canPrice && showField('单价')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Price }}</span>
              <el-input v-else v-price type="text" v-model="row.Price" :disabled="row.IsGift" @change="changePrice(row, $index)">
                <el-button v-if="row.ProductName" slot="append" @click="openSales(row, $index)" icon="el-icon-s-order"></el-button>
              </el-input>
            </template>
            <!-- <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Price }}</span>
              <el-input
                v-else
                v-price
                 type="text"
                v-model="row.Price"
                :disabled="row.IsGift"
                @input="changePrice(row, $index)"
              ></el-input>
            </template> -->
          </el-table-column>
          <el-table-column align="right" label="含税单价" min-width="100px" v-if="canPrice && showField('含税单价')">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.TaxPrice }}</span>
              <el-input v-else v-price type="text" v-model="row.TaxPrice" :disabled="row.IsGift" @input="changeTaxPrice(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="金额" min-width="100px" v-if="canPrice && showField('金额')" prop="Amount">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.Amount) }}</span>
              <el-input v-else v-decimals type="text" v-model="row.Amount" :disabled="row.IsGift" @input="changeAmount(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="税额" min-width="100px" v-if="canPrice && showField('税额')" prop="TaxLimit">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.TaxLimit) }}</span>
              <el-input v-else v-decimals type="text" v-model="row.TaxLimit" :disabled="row.IsGift" @input="changeTaxLimit(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="含税金额" min-width="100px" v-if="canPrice && showField('含税金额')" prop="TaxAmount">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.TaxAmount) }}</span>
              <el-input v-else v-decimals type="text" v-model="row.TaxAmount" :disabled="row.IsGift" @input="changeTaxAmount(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="折扣金额" min-width="100px" v-if="canPrice && showField('折扣金额')" prop="DiscountAmount">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.DiscountAmount) }}</span>
              <el-input v-else v-decimals type="text" v-model="row.DiscountAmount" :disabled="row.IsGift" @input="changeDiscountAmount(row, $index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="left" label="预计交货日期" min-width="180px" v-if="showField('预计交货日期')">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{ $commonJs.toDateString(row.DeliveryDate) }}</span>
              <el-date-picker v-else v-model="row.DeliveryDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 140px" @change="changeDeliveryDate(row)">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column align="left" label="是否布产" min-width="120px" v-if="showField('是否布产')">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{ row.IsCloth == true ? '是' : row.IsCloth == false ? '否' : '' }}</span>
              <el-select v-else v-model="row.IsCloth" @change="changeTableIsCloth(row)">
                <el-option
                  v-for="item in [
                    { label: '是', value: true },
                    { label: '否', value: false }
                  ]"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column align="center" label="赠品" v-if="showField('赠品')">
            <template slot-scope="{ row }">
              <el-checkbox @change="changeIsGift($event, row)" v-model="row.IsGift" :disabled="ReviewStatus"></el-checkbox>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="行中止" v-if="showField('行中止')">
            <template slot-scope="{ row }">
              <el-checkbox v-model="row.LineAbort" @change="changeLineAbort($event, row)" :disabled="isLineAbort || orderUpdateStatus"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column align="left" label="中止人" v-if="showField('中止人')">
            <template slot-scope="{ row }">
              <span>{{ row.LineAbortEmpName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="中止时间" min-width="100px" v-if="showField('中止时间')">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toDateString(row.LineAbortDate) }}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="right" label="已采购数量" min-width="120px" v-if="showField('已采购数量')">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.PurchaseQuantity)) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="已采购数量2" min-width="120px" v-if="showField('已采购数量2')">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.PurchaseQuantity2)) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="累计生产数量" min-width="120px" v-if="showField('累计生产数量')">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.ProductionQuantity)) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="累计生产数量2" min-width="120px" v-if="showField('累计生产数量2')">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.ProductionQuantity2)) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="执行数量" min-width="120px" v-if="showField('执行数量')">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.ExecutionQuantity)) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="执行数量2" v-if="showField('执行数量2')">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.ExecutionQuantity2)) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="来源单据" v-if="showField('来源单据')">
            <template slot-scope="{ row }">
              <span>{{ row.SourceTypeName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="来源单号" min-width="180px" v-if="showField('来源单号')">
            <template slot-scope="{ row }">
              <span>{{ row.DocNo }}</span>
            </template>
          </el-table-column>
          <!-- 字段未知 -->
          <el-table-column align="right" label="现存量" v-if="showField('现存量')">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.StockQuantity)) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="可用量" v-if="showField('可用量')">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.ExistQuantity)) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" v-if="!ReviewStatus" fixed="right">
            <template slot-scope="{ row, $index }">
              <el-button v-if="canWrite" type="text" @click.stop="delTableList(row, $index)">删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <el-form-item label="审核人:" label-width="80px" style="width: 180px">
          {{ data.ReviewEmpName }}
        </el-form-item>
        <el-form-item label="审核时间:" label-width="80px" style="width: 180px">
          {{ $commonJs.toDateString(data.ReviewDate) }}
        </el-form-item>
        <el-form-item label="变更人:" label-width="80px" style="width: 180px">
          {{ data.UpdateEmpName }}
        </el-form-item>
        <el-form-item label="变更日期:" label-width="80px" style="width: 180px">
          {{ $commonJs.toDateString(data.UpdateDate) }}
        </el-form-item>
      </el-row>
    </el-form>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <order-dialog ref="orderDialog" @save="initerPrice" in-dialog />
    <sale-quotation-select ref="saleQuotationSelect" in-dialog selectable multiple @select-multiple="setOrderList" />
    <print-dialog ref="printDialog" :columns="columns" :data="columnData" :form-data="formData"></print-dialog>
    <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" />
    <field-dialog ref="fieldDialog" @close-saved="setTbField" />
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode'
import curdMixins from '@/mixins/trend/curd'
import empDialog from '@/components/personnel/result/record/listDialog'
import orderDialog from '@/components/business/sales/saleorder/priceDialog'
import printDialog from '@/components/common/printDialog/printDialog'
import accountSelect from '@/components/business/sales/select'
import saleQuotationSelect from '@/components/business/sales/quotation/listDialog'
// import list from "@/components/business/purchase/inquiry/list";
import saleOrderList from '@/data/business/sales/saleorder/edit/list.json'
import optionMixins from '@/mixins/option'
import tradeunitDialog from '@/components/basedata/business/come/listDialog'
import fieldDialog from '@/components/common/fieldDialog'

export default {
  name: 'editSaleOrder',
  mixins: [curdMixins, optionMixins],
  components: {
    // list,
    empDialog,
    orderDialog,
    accountSelect,
    VueBarcode,
    printDialog,
    saleQuotationSelect,
    tradeunitDialog,
    fieldDialog
  },
  data() {
    return {
      api: require('@/api/sa/saOrder').default,
      adressApi: require('@/api/ba/tradeUnitContact').default,
      pdApi: require('@/api/ba/product').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      transportApi: require('@/api/ba/transport').default,
      code_api: require('@/api/sy/serialCode').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      docSetting_api: require('@/api/sy/docSetting').default,
      propertyApi: require('@/api/ba/property').default,
      propertyList: [],
      colorApi: require('@/api/ba/color').default,
      initDAccount: [],
      initTotal: 0,
      isSelect: false, // 是否有选单的操作
      DAccount: [],
      formData: [],
      columnkey: [],
      columns: [],
      columnData: [],
      colorList: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      dels: [], // 待删除的存货数组
      data: {
        OrderId: 0,
        OrderDate: this.$commonJs.getToday(),
        OrderNo: '',
        service: '',
        TransportId: null,
        Address: '',
        EmpId: null,
        MakeEmpName: '',
        DpId: 0,
        DpName: null,
        DpNo: null,
        Person: '',
        Phone: '',
        Remark: '',
        // 生产要求
        Requirement: '',
        ReviewEmpName: '',
        ReviewDate: '',
        UpdateEmpName: '',
        UpdateDate: '',
        TradeUnitId: null,
        Status: 0,
        Products: [],
        IsCloth: false
      },
      isMainUnitId2: false,
      isMainUnitId: false,
      Mode: 0,
      UseClassCode: false,
      isSave: false,
      tabPosition: '',
      reach: '联查',

      handledBy: '',
      preparedBy: '',
      IsGift: false,
      service: null,
      is_orderUpdateStatus: false,
      productList: [],
      tradeUnitList: [],
      transportList: [],
      tableList: [],
      optionList: [],
      tableColorShow: true,
      rules: {
        OrderDate: [{ required: true, message: '单据日期不能为空' }],
        OrderNo: [{ required: true, message: '单据编码不能为空' }],
        TradeUnitId: [{ required: true, message: '客户不能为空', trigger: 'change' }],
        Address: [{ required: true, message: '送货地址不能为空' }],
        EmpId: [{ required: true, message: '经手人不能为空' }],
        Remark: [{ required: true, message: '备注不能为空' }]
      },
      option: {
        // 换算率
        Iinvexchrate: 0,
        //数量
        Quantity: 0,
        //数量舍零
        IsQuantityRounding: true,
        // 单价整数
        UnitPrice: 0,
        // 单价小数
        UnitPriceDecimals: 0,
        // 单价舍零
        IsUnitPriceRounding: true
      },
      detailFields: [],
      showDetail: false,
      PropertyAccount: [],
      initPropertyAccount: [],
      initPropertyTotal: 0,
      listPropertyTotal: 0,
      pagePropertyParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      PropertyHead: [
        { Value: 'PropertyNo', Name: '属性编码', Width: '150' },
        { Value: 'PropertyName', Name: '属性名称', Width: '150' }
      ],
      options: []
    }
  },
  computed: {
    tableAmountSum() {
      let sum = 0
      let length = this.tableList.length
      for (let i = 0; i < length; ++i) {
        sum = sum + parseFloat(this.tableList[i]?.Amount ?? 0)
      }
      sum = sum.toFixed(2)
      sum = this.$commonJs.toThousands(sum)
      return sum
    },
    orderUpdateStatus() {
      return this.data.Status == 4 && !this.is_orderUpdateStatus ? true : false
    },
    ReviewName() {
      return this.data.Status >= 2 ? '弃审' : '审核'
    },
    isLineAbort() {
      return this.data.OrderId > 0 && this.data.Products.length > 0 ? false : true
    },
    ReviewStatus() {
      console.log(this.data.Status, 'this.data.Status')
      return this.data.Status == 3 || this.data.Status == 4 ? true : false
    },
    canPrice() {
      return this.$permission.canPrice('/business/sales/saleorder')
    },
    canWrite() {
      return this.$permission.canWrite('/business/sales/saleorder')
    },
    canReview() {
      return this.$permission.canReview('/business/sales/saleorder')
    }
  },
  mounted() {
    this.callOptionApi().then(res => {
      this.init()
      // this.api.list({}).then((res) => (this.productList = res.Data));
      if (this.$route.params.isSave) this.isSave = true
      if (this.$route.params.mode == 'create' || !this.$route.params.mode) {
        this.createOrder()
      }
      console.log('触发编辑')
      if (this.$route.params.mode == 'edit') {
        this.editOrder(this.$route.params.data.OrderId)
      }
      if (this.$route.params.mode == 'details') {
        this.editOrder(this.$route.params.data.OrderId)
      }
    })
  },
  methods: {
    filterSelectMethod(key) {
      console.log(key)
      if (key) {
        this.options = this.colorList.filter(item => item.ColorNo.includes(key) || item.ColorName.includes(key))
      } else {
        this.options = this.colorList
      }
    },
    onPropertySelect(val, row, index) {
      console.log(val, row, 'onPropertySelect')

      if (val) {
        row.PropertyId = val.PropertyId
        row.PropertyName = val.PropertyName
        row.PropertyNo = val.PropertyNo
      } else {
        row.PropertyNo = ''
        row.PropertyId = ''
        row.PropertyName = ''
      }

      this.$nextTick(() => {
        if (row.ColorId > 0) {
          var color = this.colorList.find(x => x.ColorId == row.ColorId)
          if (color) {
            row.ColorNo = color.ColorNo
          }
        }
        if (row.ProductId > 0) {
          var BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0)
          row.BarCode = BarCode
          console.log(row.BarCode, 'onPropertySelect')
          //(this.tableList, index, row)
          this.$set(row, 'BarCode', BarCode)
          this.tableList.splice(index, 1, row)
          this.$forceUpdate()
        }
      })
    },
    resetPropertyFun(row) {
      this.pagePropertyParams.pageIndex = 1
      this.PropertyAccount = this.initPropertyAccount
      this.listPropertyTotal = this.initPropertyTotal

      let param = { pageIndex: 1, pageSize: 7, Status: 1 }

      this.propertyApi.list(param).then(res => {
        if (res.Code == 0) {
          this.PropertyAccount = res.Data
          this.listPropertyTotal = res.Count
        }
      })
    },
    currentPropertyPage({ val, text1 }, row) {
      console.log(val, text1, row)
      this.pagePropertyParams.pageIndex = val

      let param = { pageIndex: val, pageSize: 7, Status: 1, PropertyName: text1 }

      this.propertyApi.list(param).then(res => {
        if (res.Code == 0) {
          this.PropertyAccount = res.Data
          this.listPropertyTotal = res.Count
        }
      })
    },
    inputPropertyText(text) {
      this.propertyApi
        .list({
          PageIndex: 1,
          PageSize: 7,
          PropertyName: text,
          Status: 1
        })
        .then(res => {
          if (res.Code == 0) {
            this.PropertyAccount = res.Data
            this.listPropertyTotal = res.Count
          }
        })
    },
    openSetField() {
      this.$refs.fieldDialog.open().then(that => {
        that.getData({ DocType: '销售订单', Url: 'business/sales/saleorder/edit' })
      })
    },
    setTbField() {
      this.showDetail = false
      this.docSetting_api.list({ DocType: '销售订单', IsShow: true }).then(res => {
        if (res.Code == 0) {
          this.detailFields = res.Data.map(x => x.FormKey)
          this.$nextTick(() => {
            this.showDetail = true
          })
        }
      })
    },
    showField(type) {
      return this.detailFields.indexOf(type) != -1
    },
    changeIsCloth(val) {
      this.tableList.forEach(item => {
        if (item.T === 3) item.T = 1
        if (item.IsCloth == true || item.IsCloth == false) item.IsCloth = val
      })
    },
    changeTableIsCloth(row) {
      if (row.T === 3) row.T = 1
      this.data.IsCloth = !this.tableList.some(item => item.IsCloth == false)
    },
    async goJump(index) {
      let params = {}
      let ids = []
      let res = null
      switch (index) {
        case 1:
          res = await this.sourceTypeApi.info('报价单')
          params.SourceType = res.SourceTypeId
          ids = this.data.Products.map(item => {
            return item.QuotationId
          })
          if (ids.length === 0) {
            this.$message.error('单据未引用报价单，无法进行联查')
          } else {
            params.Ids = ids
            this.$router.push({ name: 'quotation', params: params })
          }
          break
        case 2:
          params.SourceDocNo = this.data.OrderNo
          res = await this.sourceTypeApi.info('销售订单')
          params.OrderType = res.SourceTypeId
          this.$router.push({ name: 'sale', params: params })
          break
        case 3:
          params.SaOrderNo = this.data.OrderNo
          res = await this.sourceTypeApi.info('销售订单')
          params.SourceType = res.SourceTypeId
          this.$router.push({ name: 'emptor', params: params })
          break
        case 4:
          params.SaOrderNo = this.data.OrderNo
          res = await this.sourceTypeApi.info('销售订单')
          params.SourceType = res.SourceTypeId
          this.$router.push({ name: 'inquiry', params: params })
          break
        case 5:
          params.SaOrderNo = this.data.OrderNo
          res = await this.sourceTypeApi.info('销售订单')
          params.SourceType = res.SourceTypeId
          this.$router.push({ name: 'selloutwarehouse', params: params })
          break
        case 6:
          params.SaOrderNo = this.data.OrderNo
          res = await this.sourceTypeApi.info('销售订单')
          params.SourceType = res.SourceTypeId
          this.$router.push({ name: 'receivables', params: params })
          break
        case 7:
          params.SaOrderNo = this.data.OrderNo
          res = await this.sourceTypeApi.info('销售订单')
          params.SourceType = res.SourceTypeId
          this.$router.push({ name: 'demand', params: params })
          break
        case 8:
          params.OrderNo = this.data.OrderNo
          params.ProductionType = 0
          this.$router.push({ name: 'workorder', params: params })
          break
        case 9:
          params.OrderNo = this.data.OrderNo
          params.ProductionType = 1
          this.$router.push({ name: 'workorder', params: params })
          break
      }
    },
    onInsert(e) {
      let { type, index } = e

      this.interpolate(null, index, type)
    },
    interpolate(row, index, type = '') {
      let o = {
        T: 0,
        StockQuantity: 0,
        ExistQuantity: 0,
        OrderProductId: 0,
        OrderId: 0,
        QuotationId: 0,
        QuotationProductId: 0,
        ProductId: 0,
        ColorId: null,
        SaUnitId: 0,
        SaQuantity: 0,
        UnitId2: 0,
        Quantity2: 0,
        Rate: 0,
        QuotedPrice: 0,
        Discount: 100,
        TaxRate: 0,
        Price: 0,
        TaxPrice: 0,
        Amount: 0,
        TaxAmount: 0,
        TaxLimit: 0,
        DiscountAmount: 0,
        DeliveryDate: '',
        BatchNumber: null,
        IsBatchNumber: false,
        IsGift: false,
        LineAbort: false,
        LineAbortEmpId: 0,
        LineAbortDate: '',
        Requirement: '',
        UseStockQuantity: 0,
        ClothQuantity: 0,
        ProductionStatus: 0,
        TeProductId: 0,
        Remark: '',
        ProductionDpId: 0,
        PurchaseQuantity: 0,
        PurchaseQuantity2: 0,
        ProductionQuantity: 0,
        ProductionQuantity2: 0,
        ExecutionQuantity: 0,
        ExecutionQuantity2: 0,
        MultiWorkDocId: 0,
        ProductNo: '',
        ProductName: '',
        ProductSpec: '',
        ShortName: '',
        OrderNo: '',
        TradeUnitNo: '',
        TradeUnitShortName: '',
        FullName: '',
        TradeUnitId: 0,
        EmpName: '',
        DpName: '',
        Status: 0,
        OrderProductNo: '',
        Property: '',
        SettleName: '',
        SettleNo: '',
        ChargeEmpName: '',
        ChargeDpName: '',
        DocNo: '',
        IsMain: false,
        SourceTypeName: '',
        IsCloth: false,
        ClothDocDate: null,
        HasGrammage: false,
        Grammage: null
      }
      if (type == 'down') {
        index = index + 1
      }
      this.tableList.splice(index, 0, o)
      let copy = JSON.parse(JSON.stringify(this.tableList))
      this.tableList = []
      this.$nextTick(() => {
        this.tableList = copy
      })
    },
    openTradeunit() {
      if (!this.isSelect) {
        this.$refs.tradeunitDialog.open().then(that => {
          that.getData({ TradeUnitTypes: [0, 2] })
        })
      }
    },
    previewNo(val = '') {
      this.code_api.previewNo('销售订单', val).then(res => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.UseClassCode = res.Data.UseClassCode
          if (this.UseClassCode) {
            this.data.OrderNo = ''
          } else {
            this.data.OrderNo = res.Data.PreviewNo
          }
          if (this.tableList.length > 0) {
            this.tableList.forEach(item => {
              if (item.IsBatchNumber) {
                item.BatchNumber = this.$commonJs.toDateStringByFormat(this.data.OrderDate, 'YYMMDD') + '-' + this.data.TradeUnitNo + '-' + item.ProductNo
              }
            })
          }
        } else {
          this.$message.warning('获取销售订单编码失败')
        }
      })
    },
    init() {
      this.tradeUnitApi.list({ TradeUnitTypes: [0, 2], Status: 1 }).then(res => {
        if (res.Code == 0) {
          this.tradeUnitList = res.Data
          // for(let i = 0; i < 50; ++i){
          //   this.tradeUnitList.push({
          //     TradeUnitId: i,
          //     FullName: '_' + i
          //   })
          // }
        }
      })
      this.transportApi.list({}).then(res => {
        if (res.Code == 0) this.transportList = res.Data
      })
      this.pdApi.list({ Property: '销售', pageIndex: 1, pageSize: 7, Status: 1 }).then(res => {
        this.DAccount = res.Data
        this.initDAccount = res.Data
        this.listTotal = res.Count
        this.initTotal = res.Count
      })

      this.colorApi.list({ Status: 1 }).then(res => {
        if (res.Code == 0) {
          this.colorList = res.Data
          this.options = res.Data
        }
      })
      this.propertyApi.list({ Status: 1 }).then(res => {
        if (res.Code == 0) {
          this.propertyList = res.Data
        }
      })

      this.setTbField()
    },
    createOrder() {
      const user = this.$store.state.user
      if (user) {
        this.data.EmpId = user.empId
        this.data.EmpName = user.name
        this.data.MakeEmpId = user.id
        this.data.MakeEmpName = user.name
      }
      this.addList()
      this.previewNo()
    },
    editOrder(data, type = 0) {
      console.log('执行编辑', data)
      this.api.info(data).then(res => {
        if (res.Code === 0) {
          this.isSave = true
          this.data = res.Data

          if (this.data.TransportId == 0) {
            //h    <!-- h -->
            this.data.TransportId = null
          }

          this.tableList = res.Data.Products?.map(item => ((item.T = 3), item))
          this.tableList.forEach((item, i) => {
            if (item.Units.length > 0 && item.SaUnitId && item.UnitId2) {
              const findIndex = item.Units.findIndex(el => el.UnitId == item.SaUnitId)
              const IsMainIndex = item.Units.findIndex(el => el.IsMain == true) //主单位的索引
              const noMainIndex = item.Units.findIndex(e => e.IsMain == false) //不是主单位的索引
              if (findIndex == IsMainIndex) {
                //判断当前销售单位是否为主单位
                item.Rate = item.Units[noMainIndex].Rate
                item.ChangeType = item.Units[noMainIndex].ChangeType
                item.IsMain = true
              } else {
                //如果当前是赋单位
                item.Rate = item.Units[noMainIndex].Rate
                item.ChangeType = item.Units[noMainIndex].ChangeType
                item.IsMain = false
              }

              this.changeQuantity(item.SaQuantity, item, i)
            } else {
              item.Units.forEach(v => {
                if (v.ChangeType == 1) item.ChangeType = v.ChangeType
              })
            }
          })
          if (type === 1) {
            this.Review()
          }
        }
        if (res.Data.Products.length == 0) this.addList()
      })
    },
    async toggleOrder() {
      //TradeUnitName
      const res = await this.sourceTypeApi.info('销售订单')
      let OrderType = res.SourceTypeId

      let that = await this.$refs.saleQuotationSelect.open()
      if (this.data.FullName) {
        that.getData({ TradeUnitName: this.data.FullName })
      } else {
        that.getData({ OrderType })
      }
    },
    // 获取进货单明细
    async setOrderList(data) {
      if (data.Address) {
        this.data.Address = data.Address
      }
      if (data.TradeUnitId > 0) {
        this.data.FullName = data.FullName
        this.data.TradeUnitId = data.TradeUnitId
      }
      if (data.TransportId) {
        this.data.TransportId = data.TransportId
      }
      let Quantity = this.tableList.map(i => i.ProductId)
      console.log('===data=====', data)
      // if(data.)
      const res = await this.sourceTypeApi.info('报价单')
      let SourceType = res.SourceTypeId

      let addList = data.List.reduce((arr, item) => {
        if (!Quantity.includes(item.ProductId)) {
          let UnitType = 0
          if (item.Units.length != 0) {
            UnitType = 1
          }
          arr.push({
            T: 0,
            PurchaseQuantity: 0,
            PurchaseQuantity2: 0,
            ProductionQuantity: 0,
            ProductionQuantity2: 0,
            ExecutionQuantity: 0,
            ExecutionQuantity2: 0,
            StockQuantity: 0,
            ExistQuantity: 0,

            Requirement: '',
            ...item,
            OrderProductId: 0,
            OrderId: 0,
            SourceTypeName: '报价单',
            SourceType,
            DocNo: '',
            LineAbort: false,
            LineAbortEmpName: '',
            LineAbortDate: '',
            UnitType: UnitType,
            SourceNo: data.Order
          })
        } else {
          this.$message.warning('已有相同订单')
        }
        return arr
      }, [])
      console.log('addList', addList)
      addList.forEach((item, i) => {
        item.ChangeType = 0
        // item.Units.forEach(v=>{
        //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
        // })
        if (item.Units.length > 0 && item.SaUnitId && item.UnitId2) {
          const findIndex = item.Units.findIndex(el => el.UnitId == item.SaUnitId)
          const IsMainIndex = item.Units.findIndex(el => el.IsMain == true) //主单位的索引
          const noMainIndex = item.Units.findIndex(e => e.IsMain == false) //不是主单位的索引
          if (findIndex == IsMainIndex) {
            //判断当前销售单位是否为主单位
            item.Rate = item.Units[noMainIndex].Rate
            item.ChangeType = item.Units[noMainIndex].ChangeType
            item.IsMain = true
          } else {
            //如果当前是赋单位
            item.Rate = item.Units[noMainIndex].Rate
            item.ChangeType = item.Units[noMainIndex].ChangeType
            item.IsMain = false
          }

          this.changeQuantity(item.SaQuantity, item, i)
        } else {
          item.Units.forEach(v => {
            if (v.ChangeType == 1) item.ChangeType = v.ChangeType
          })
        }
      })
      // console.log(addList, 'addList');
      this.tableList.unshift(...addList)
      if (this.data.TradeUnitId) {
        this.isSelect = true
      }
      //TradeUnitId
      // console.log("Quantity", this.tableList);
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage({ val, text1 }) {
      this.pageParams.pageIndex = val
      this.pdApi
        .list({
          Property: '销售',
          pageIndex: val,
          pageSize: 7,
          Status: 1,
          ProductName: text1
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data
            this.listTotal = res.Count
          }
        })
    },
    inputText(text) {
      this.pdApi
        .list({
          Property: '销售',
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
          Status: 1
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data
            this.listTotal = res.Count
          }
        })
    },
    setProduct(row, index) {
      let data = this.productList.filter(item => item.ProductId === row.ProductId)
      this.tableList[index].ProductName = data[0].ProductName
      this.tableList[index].ProductNo = data[0].ProductNo
      this.tableList[index].ProductSpec = data[0].ProductSpec
      this.tableList[index].SaUnitName = data[0].SaUnitName
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    // 选择存货名称
    onSelect(e, row, index) {
      console.log('e', e)
      // let Product = this.tableList.map((i) => i.ProductId);
      // if (Product.includes(e.ProductId))
      //   return this.$message.warning("产品已存在");
      if (this.data.TradeUnitId === null) return this.$message.warning('请先选择客户')

      if (row.SourceNo && row.ProductId !== e.ProductId) {
        // this.data.TradeUnitId = '';
        // this.data.FullName = '';
        // this.isSelect = false;
        // this.$nextTick(() => {
        //   this.$refs.ruleForm.clearValidate();
        // })
        row.SourceNo = ''
      }
      if (row.T === 3 && row.ProductId !== e.ProductId) row.T = 1
      row.ProductNo = e.ProductNo
      row.ProductName = e.ProductName
      row.ProductId = e.ProductId
      row.ProductSpec = e.ProductSpec
      row.SaUnitId = e.SaUnitId
      row.SaUnitName = e.SaUnitName
      row.IsBatchNumber = e.BatchNumber ?? null
      row.UseColor = e.UseColor
      row.Colors = e.Colors
      row.ColorId = null
      row.ColorNo = ''
      row.ColorName = ''
      row.IsCloth = this.data.IsCloth
      ;(row.IsMain = false), //是否为浮动
        (row.ChangeType = 0), //是否浮动
        (row.Units = e.Units)
      row.UnitType = 0
      row.ExistQuantity = e.ExistQuantity
      row.StockQuantity = e.StockQuantity
      let findIndex = ''
      row.ChangeType = 0
      row.rightChangeType = 0
      row.HasGrammage = e.HasGrammage ?? false
      row.Grammage = e.Grammage ?? 0
      row.RetailPrice = 0
      row.Amount = 0
      row.TaxLimit = 0
      row.TaxAmount = 0
      row.DiscountAmount = 0
      row.Discount = 100
      row.TaxRate = 0
      row.PropertyId = null
      row.PropertyName = ''
      row.PropertyNo = ''
      row.UseProcess = e.UseProcess
      row.TrademarkNo = e.TrademarkNo
      row.BarCode = e.ProductNo + '*0*0*0'
      if (row.TrademarkNo) {
        row.BarCode = e.ProductNo + '*0*0*' + (row.TrademarkNo || '0')
      }
      if (row.IsBatchNumber) {
        row.BatchNumber = this.$commonJs.toDateStringByFormat(this.data.OrderDate, 'YYMMDD') + '-' + this.data.TradeUnitNo + '-' + row.ProductNo
      }
      if (e.Units.length === 0) {
        row.UnitName = e.PuUnitName
        row.UnitId2 = 0
        row.SaUnitName = e.SaUnitName
        row.UnitName2 = ''
        row.Rate = 0
        row.Quantity2 = 0
      } else {
        row.UnitType = 1
        // e.Units.find(e.ChangeType)
        e.Units.forEach(item => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType
        })
        if (row.SaUnitId) {
          let IsMainIndex = 0
          let noMainIndex = 0
          findIndex = e.Units.findIndex(el => row.SaUnitId == el.UnitId) //获取当前带出的索引
          row.ChangeType = e.Units[findIndex].ChangeType //获取带出的单据的type 如果是浮动 会是1

          // console.log(row.leftChangeType,'row.leftChangeType')
          IsMainIndex = e.Units.findIndex(el => el.IsMain == true) //主单位的索引
          noMainIndex = e.Units.findIndex(el => el.IsMain == false) //不是主单位的索引
          if (findIndex == IsMainIndex) {
            //判断当前销售单位是否为主单位
            row.UnitId2 = e.Units[noMainIndex].UnitId
            row.UnitName2 = e.Units[noMainIndex].UnitName
            row.Rate = this.getIinvexchrate(e.Units[noMainIndex].Rate)
            row.ChangeType = e.Units[noMainIndex].ChangeType
            row.IsMain = true
          } else {
            //如果当前是赋单位
            row.UnitId2 = e.Units[IsMainIndex].UnitId
            row.UnitName2 = e.Units[IsMainIndex].UnitName
            row.Rate = this.getIinvexchrate(e.Units[noMainIndex].Rate)
            row.IsMain = false
          }
        } else {
          let untiLength = e.Units.length
          let mainData = []
          let noMainData = []
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.SaUnitId = mainData[0].UnitId
          row.SaUnitName = mainData[0].UnitName
          row.UnitId2 = noMainData[0].UnitId
          row.UnitName2 = noMainData[0].UnitName
          row.Rate = this.getIinvexchrate(noMainData[0].Rate)
          row.IsMain = true
        }
        if (row.IsMain) {
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.SaQuantity * Number(row.Rate))
          } else {
            row.Quantity2 = this.getQuantity(row.SaQuantity / Number(row.Rate))
          }
        } else {
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.SaQuantity / Number(row.Rate))
          } else {
            row.Quantity2 = this.getQuantity(row.SaQuantity * Number(row.Rate))
          }
        }
        row.Amount = Number(row.Price ?? 0) * Number(row.SaQuantity ?? 0)
        row.TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0)
      }
      //   let _colorShow=this.tableList.find(item=>item.UseColor==true)
      //   //SaUnitId 销售单位
      //  if(_colorShow){
      //   this.tableColorShow=true
      //  }else{
      //   this.tableColorShow=false
      //  }

      this.api
        .productPrice({
          TradeUnitId: this.data.TradeUnitId,
          ProductId: e.ProductId
        })
        .then(res => {
          if (res.Data) {
            row.SalePrice = res.Data.SalePrice
            row.RetailPrice = res.Data.RetailPrice
            row.PurchasePrice = res.Data.PurchasePrice
            //QuotationPrice
            row.QuotedPrice = res.Data.QuotationPrice
            row.Price = res.Data.QuotationPrice
            row.TaxPrice = res.Data.QuotationPrice
            if (res.Data.Discount > 0) {
              row.Discount = res.Data.Discount
            }
            this.changeQuotedPrice(row, index)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    addColumn(row, column) {
      if (row.index === this.tableList.length - 1 && !this.ReviewStatus) {
        this.addList()
      }
    },
    compareSaUnit(data, row, index) {
      if (row.T == 3) this.tableList[index].T = 1
      let findindex = ''
      this.tableList[index].IsMain = data.IsMain //判断当前是左边是否为主单位
      if (this.tableList[index].SaUnitId == this.tableList[index].UnitId2) {
        let num = 0
        num = this.tableList[index].SaQuantity
        this.tableList[index].SaQuantity = this.tableList[index].Quantity2
        this.tableList[index].Quantity2 = num
        //相同单位
        if (data.IsMain == false) {
          //当前不是主单位
          findindex = this.tableList[index].Units.findIndex(el => el.IsMain == true)
          this.tableList[index].UnitId2 = this.tableList[index].Units[findindex].UnitId
          this.tableList[index].UnitName2 = this.tableList[index].Units[findindex].UnitName
          //  this.tableList[index].Rate=data.Rate //带出不是主单位的换算率
          this.tableList[index].ChangeType = data.ChangeType
        } else {
          //当前是主单位
          findindex = this.tableList[index].Units.findIndex(el => el.IsMain == false)
          this.tableList[index].UnitId2 = this.tableList[index].Units[findindex].UnitId
          this.tableList[index].UnitName2 = this.tableList[index].Units[findindex].UnitName

          //  this.tableList[index].rightChangeType=!data.ChangeType
        }
      } else {
        let UnitId2Index = this.tableList[index].Units.findIndex(el => this.tableList[index].SaUnitId == el.UnitId) //获取销售单位的索引
        let Rate = this.tableList[index].Units[UnitId2Index].Rate //获取销售单位的换算率
        let IsMain1Index = this.tableList[index].Units.findIndex(el => el.IsMain == true) //获取主计量的索引
        let noMainIndex = this.tableList[index].Units.findIndex(el => el.IsMain == false) //获取赋计量的索引
        //  this.tableList[index].leftChangeType=data.ChangeType
        if (data.IsMain) {
          this.tableList[index].UnitId2 = this.tableList[index].Units[noMainIndex].UnitId
          this.tableList[index].UnitName2 = this.tableList[index].Units[noMainIndex].UnitName
          this.tableList[index].ChangeType == this.tableList[index].Units[noMainIndex].ChangeType
          //  this.tableList[index].Rate=Rate  //当前是主单位 只需要让换算率是销售单位的换算率
        } else {
          this.tableList[index].UnitId2 = this.tableList[index].Units[IsMain1Index].UnitId
          this.tableList[index].UnitName2 = this.tableList[index].Units[IsMain1Index].UnitName
          this.tableList[index].ChangeType == this.tableList[index].Units[IsMain1Index].ChangeType
          this.tableList[index].Rate = Rate //当前是主单位 只需要让换算率是销售单位的换算率
        }
      }
      this.changeQuantity(this.tableList[index].SaQuantity, row, index)
    },
    RateChange(data, row, index) {
      if (data < 0 || data == '') return
      if (row.T == 3) this.tableList[index].T = 1
      this.changeQuantity(this.tableList[index].SaQuantity, row, index)
    },
    compareUnitId(data, row, index) {
      let findindex = ''
      if (row.T == 3) this.tableList[index].T = 1
      if (this.tableList[index].SaUnitId == this.tableList[index].UnitId2) {
        //判断当前是否是替换
        let num = 0
        num = this.tableList[index].SaQuantity
        this.tableList[index].SaQuantity = this.tableList[index].Quantity2
        this.tableList[index].Quantity2 = num
        let findFalse = this.tableList[index].Units.findIndex(el => el.IsMain == false) //获取数组第一个不是主单位的换算率
        //相同单位
        if (data.IsMain == false) {
          //当前选择的是否为主单位
          findindex = this.tableList[index].Units.findIndex(el => el.IsMain == true)
          this.tableList[index].SaUnitId = this.tableList[index].Units[findindex].UnitId
          this.tableList[index].SaUnitName = this.tableList[index].Units[findindex].UnitName
          this.tableList[index].IsMain = this.tableList[index].Units[findindex].IsMain //判断当前是左边是否为主单位
          this.tableList[index].ChangeType = data.ChangeType
        } else {
          //当前是主单位
          findindex = this.tableList[index].Units.findIndex(el => el.IsMain == false)
          this.tableList[index].SaUnitId = this.tableList[index].Units[findindex].UnitId
          this.tableList[index].SaUnitName = this.tableList[index].Units[findindex].UnitName
          this.tableList[index].IsMain = this.tableList[index].Units[findindex].IsMain //判断当前是左边是否为主单位
        }
      } else {
        let UnitId2Index = this.tableList[index].Units.findIndex(el => this.tableList[index].SaUnitId == el.UnitId) //获取销售单位的索引
        let Rate = this.tableList[index].Units[UnitId2Index].Rate //获取销售单位的换算率
        let IsMain2Index = this.tableList[index].Units.findIndex(el => el.IsMain == false) //获取不是主计量的索引
        let IsMain1Index = this.tableList[index].Units.findIndex(el => el.IsMain == true) //获取不是主计量的索引
        if (data.IsMain) {
          this.tableList[index].SaUnitId = this.tableList[index].Units[IsMain2Index].UnitId
          this.tableList[index].SaUnitName = this.tableList[index].Units[IsMain2Index].UnitName
          this.tableList[index].IsMain = this.tableList[index].Units[IsMain2Index].IsMain //判断当前是左边是否为主单位
          this.tableList[index].Rate = Rate
        } else {
          this.tableList[index].SaUnitId = this.tableList[index].Units[IsMain1Index].UnitId
          this.tableList[index].SaUnitName = this.tableList[index].Units[IsMain1Index].UnitName
          this.tableList[index].IsMain = this.tableList[index].Units[IsMain1Index].IsMain //判断当前是左边是否为主单位
          this.tableList[index].ChangeType == this.tableList[index].Units[IsMain1Index].ChangeType
          this.tableList[index].Rate = data.Rate
        }
      }
      this.changeQuantity2(this.tableList[index].Quantity2, row, index)
    },
    changeDeliveryDate(row) {
      if (row.T === 3) row.T = 1
    },
    changeIsGift(data, row) {
      if (row.T === 3) row.T = 1
      if (data) {
        row.QuotedPrice = 0
        row.Discount = 0
        row.TaxRate = 0
        row.Price = 0
        row.TaxPrice = 0
        row.Amount = 0
        row.TaxLimit = 0
        row.TaxAmount = 0
        row.DiscountAmount = 0
      }
    },
    RestartOrder() {
      // this.$message.success("新增");
      Object.assign(this.$data, this.$options.data.call(this))
      this.init()
      this.createOrder()
      // this.addList();
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate()
      }, 30)
    },
    orderUpdate() {
      this.$message.success('变更')
      this.is_orderUpdateStatus = true
    },
    Review() {
      this.api.review(this.data.OrderId).then(res => {
        this.data.Status = 2
        res.Code === 0 ? this.$message.success(res.Msg) : this.$message.warning(res.Msg)

        if (res.Code === 0) {
          this.editOrder(this.data.OrderId)
          // this.api.info(this.data.OrderId).then((res) => {
          //   this.data = res.Data;
          // });
        }
      })
    },
    orderReview() {
      if (this.data.OrderId == 0) {
        this.$message.warning('订单未保存')
        return
      }
      const message = this.data.Status >= 2 ? '确认要弃审吗？ ' : '确认提交审核吗？'
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const data = this.data.Status >= 2 ? 'back' : 'review'
          if (data === 'review') {
            this.save(1)
          } else if (data === 'back') {
            this.api[data](this.data.OrderId).then(res => {
              if (res.Code === 0 && data == 'review') {
                this.data.Status = 2
              }
              if (res.Code === 0 && data == 'back') this.data.Status = 0
              res.Code === 0 ? this.$message.success(res.Msg) : this.$message.warning(res.Msg)

              if (res.Code === 0) {
                this.editOrder(this.data.OrderId)
                // this.api.info(this.data.OrderId).then((res) => {
                //   this.data = res.Data;
                // });
              }
            })
          }
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {})
    },
    orderDel() {
      // let rows = this.$refs.list.getCheckedRows();
      if (this.data.OrderId == 0) {
        this.$message.warning('订单未保存')
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.api.delete({ Id: this.data.OrderId }).then(res => {
            if (res.Code === 0) this.RestartOrder()
            res.Code === 0 ? this.$message.success(res.Msg) : this.$message.warning(res.Msg)
          })
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {})
    },
    delTableList(row, index) {
      // if (data.SourceNo) {
      //   // this.data.TradeUnitId = '';
      //   this.data.FullName = '';
      //   this.isSelect = false;
      //   this.$nextTick(() => {
      //     this.$refs.ruleForm.clearValidate();
      //   })
      // }
      if (row.T !== 0) {
        row.T = 2
        this.dels.push(row)
      }
      this.$message.success('删除')
      this.tableList.splice(index, 1)

      if (this.tableList.length === 0) this.addList()
      if (this.tableList.length === 0) {
        this.isSelect = false
      }
    },
    openEmp() {
      this.$refs.empDialog.open().then(that => {
        that.getData()
      })
    },
    setEmp(data) {
      console.log(data)
      this.data.EmpId = data.EmpId
      this.data.EmpName = data.EmpName
      this.data.DpId = data.DpId
      this.data.DpName = data.DpName
      this.data.DpNo = data.DpNo
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows()
      if (rows.length == 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids = rows.map(item => {
            return item.PropertyId
          })
          this.$refs.list.delRange(ids)
        })
        .catch(() => {})
    },
    //单据保存回显
    initerPrice(price) {
      this.currentRow.Price = price
      this.changePrice(this.currentRow, this.currentIndex)
    },
    openSales(row, index) {
      this.currentRow = row
      this.currentIndex = index
      let ProductName = row.ProductName
      let TradeUnitName = this.data.TradeUnitName
      this.$refs.orderDialog.open().then(that => {
        that.setData(ProductName, TradeUnitName)
      })
      // this.$refs.orderDialog.open();
    },
    setTradeunit(data) {
      console.log(data, 'data')
      // this.data.TradeUnitId = data.TradeUnitId;
      // this.data.FullName = data.FullName;
      this.data.TradeUnitId = data.TradeUnitId
      this.data.TradeUnitNo = data.TradeUnitNo
      this.data.FullName = data.FullName
      this.data.TradeUnitType = data.TradeUnitType
      //DistrictName
      this.data.Address = ''
      if (!this.data.Address) {
        //  adressApi.list
        let params = {
          pageIndex: 1,
          pageSize: 10,
          TradeUnitId: this.data.TradeUnitId
        }
        params = JSON.parse(JSON.stringify(params))
        this.adressApi.list(params).then(res => {
          if (res.Code === 0 && res.Data.length) {
            this.data.Address = res.Data[0].ArrivalAddress
          }
          if (res.Code === 1) {
            this.$message.error(res.Msg)
          }
        })
      }
      if (this.UseClassCode) {
        this.code_api.previewNo('销售订单', this.data.OrderDate, 0, data.TradeUnitId).then(res => {
          // console.log("serialType", res);
          if (res.Code == 0) {
            this.Mode = res.Data.Mode
            this.UseClassCode = res.Data.UseClassCode
            this.data.OrderNo = res.Data.PreviewNo
          
          } else {
            this.$message.warning('获取销售订单编码失败')
          }
        })
      }  if (this.tableList.length > 0) {
              this.tableList.forEach(item => {
                if (item.IsBatchNumber) {
                  item.BatchNumber = this.$commonJs.toDateStringByFormat(this.data.OrderDate, 'YYMMDD') + '-' + this.data.TradeUnitNo + '-' + item.ProductNo
                }
              })
            }
    },
    // 貌似需要审核后才可以进行 修改 行中止
    changeLineAbort(data, row) {
      if (this.data.OrderId == 0 || row.OrderProductId == 0) return (row.LineAbort = false)
      this.api
        .lineAbort({
          Id: row.OrderProductId,
          IsLineAbort: data
        })
        .then(res => {
          if (res.Code === 1) {
            row.LineAbort = !data
            return this.$message.error(res.Msg)
          }
        })
    },
    changeProperty(val, row, index) {
      if (row.T === 3) this.tableList[index].T = 1
      var pm = { ProductId: row.ProductId, ColorId: row.ColorId, PropertyId: row.PropertyId }
      this.pdApi.stockInfo(pm).then(res => {
        if (res.Code == 0) {
          row.ExistQuantity = res.Data.AvailableQuantity
          row.StockQuantity = res.Data.StockQuantity
        }
      })

      row.PropertyNo = ''
      let item = this.propertyList.filter(item => {
        return item.PropertyId === val
      })[0]
      row.PropertyNo = item.PropertyNo
      row.PropertyName = item.PropertyName
      if (row.ProductId > 0) {
        row.BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0) + '*' + (row.TrademarkNo || 0)
      }
    },
    changeColor(val, row, index) {
      if (row.T === 3) this.tableList[index].T = 1
      var pm = { ProductId: row.ProductId, ColorId: row.ColorId, PropertyId: row.PropertyId }
      this.pdApi.stockInfo(pm).then(res => {
        if (res.Code == 0) {
          row.ExistQuantity = res.Data.AvailableQuantity
          row.StockQuantity = res.Data.StockQuantity
        }
      })

      row.colorNo = ''
      let item = this.colorList.filter(item => {
        return item.ColorId === val
      })[0]
      row.ColorNo = item.ColorNo
      row.ColorName = item.ColorName
      if (row.ProductId > 0) {
        row.BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0) + '*' + (row.TrademarkNo || 0)
      }
      this.options = this.colorList
    },
    validInput(row, index, type) {
      if (row.T === 3) this.tableList[index].T = 1
      if (!Number(row.SaQuantity)) {
        this.$message.warning('请先填写数量')
        return true
      }
      return false
    },
    changeQuantity2(data, row, index) {
      console.log(row, data, 'rowchange2')
      if (data < 0 || data == '') return
      //console.log(leftChangeType,'leftChangeType')
      if (row.T == 3) this.tableList[index].T = 1
      data = this.getQuantity(data)
      row.Quantity2 = data
      if (row.IsMain == false) {
        if (row.ChangeType == 1) {
          if (row.SaQuantity === '' || row.SaQuantity === 0) {
            return
          }
          if (row.HasGrammage == true) {
            row.SaQuantity = this.getQuantity(data * row.Rate)
          } else {
            row.Rate = this.getIinvexchrate(data / row.SaQuantity)
          }
        } else {
          console.log('数量1=数量2/换算率')
          row.SaQuantity = this.getQuantity(data / row.Rate)
        }
      } else {
        if (row.ChangeType == 1) {
          if (row.SaQuantity === '' || row.SaQuantity === 0) {
            return
          }
          if (row.HasGrammage == true) {
            row.SaQuantity = this.getQuantity(data / row.Rate)
          } else {
            row.Rate = this.getIinvexchrate(row.SaQuantity / data)
          }
        } else {
          console.log('数量1=数量2*换算率')
          row.SaQuantity = this.getQuantity(data * row.Rate)
        }
      }
    },
    getChangeQuantity(data, row, index) {
      if (row.SaQuantity === '' || row.SaQuantity === 0) {
        if (row.Quantity2 && row.Rate) {
          if (row.IsMain) {
            if (row.HasGrammage == true) {
              row.SaQuantity = this.getQuantity(row.Quantity2 / Number(row.Rate))
            } else {
              row.SaQuantity = this.getQuantity(row.Quantity2 * Number(row.Rate))
            }
          } else {
            if (row.HasGrammage == true) {
              row.SaQuantity = this.getQuantity(row.Quantity2 * Number(row.Rate))
            } else {
              row.SaQuantity = this.getQuantity(row.Quantity2 / Number(row.Rate))
            }
          }
        }
      }
    },
    changeQuantity(data, row, index) {
      if (data < 0 || data == '') return
      data = this.getQuantity(data)
      row.SaQuantity = data

      if (row.IsMain) {
        if (row.HasGrammage == true) {
          row.Quantity2 = this.getQuantity(row.SaQuantity * row.Rate)
        } else {
          row.Quantity2 = this.getQuantity(row.SaQuantity / row.Rate)
        }
      } else {
        if (row.HasGrammage == true) {
          row.Quantity2 = this.getQuantity(row.SaQuantity / row.Rate)
        } else {
          row.Quantity2 = this.getQuantity(row.SaQuantity * row.Rate)
        }
      }
      //数量2  数量 * 换算率

      if (row.T == 3) row.T = 1
      // if (this.optionList.length > 0) {
      //   const mainList = this.optionList
      //     .filter((i) => i.IsMain)
      //     .map((sub) => sub.UnitId);
      //   if (mainList.includes(row.SaUnitId) && this.isMainUnitId2 == false){
      //     console.log('======row.Rate=======', row.Rate)
      //     row.Quantity2 = row.SaQuantity / row.Rate;
      //   }
      //   else if (!mainList.includes(row.SaUnitId) && this.isMainUnitId2 == true){
      //     row.Quantity2 = row.SaQuantity * row.Rate;
      //   }
      //   else row.Quantity2 = Number(row.SaQuantity);
      // } else row.Quantity2 = Number(row.SaQuantity);

      // 金额
      if (Number(row.Price)) {
        // let Amount =
        //   Number(row.Price) * data * (Number(row.Discount ?? 0) / 100);
        let Amount = Number(row.Price) * data
        row.Amount = Number(Amount.toFixed(2))
      }

      // 税额
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * data * (Number(row.TaxRate) / 100)
        row.TaxLimit = Number(TaxLimit.toFixed(2))
      }

      // 含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100
        row.TaxPrice = Number(this.getPrice(TaxPrice))
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0)
        row.TaxAmount = Number(TaxAmount.toFixed(2))
      }

      // 折扣金额
      if (Number(row.QuotedPrice) && Number(row.Price)) {
        let DiscountAmount = (Number(row.QuotedPrice) - Number(row.Price)) * Number(data)
        row.DiscountAmount = Number(DiscountAmount.toFixed(2))
      }
    },
    // 报价
    changeQuotedPrice(row, index) {
      if (row.QuotedPrice == null || row.QuotedPrice == '') {
        row.QuotedPrice = 0
      }
      // row.QuotedPrice = parseFloat(row.QuotedPrice)
      if (row.T === 3) this.tableList[index].T = 1
      // 修改单价
      let Price = (row.Discount / 100) * row.QuotedPrice
      this.tableList[index].Price = Price < 0 ? 0 : Number(this.getPrice(Price))

      //修改金额
      let Amount = Number(row.Price ?? 0) * Number(row.SaQuantity ?? 0)
      this.tableList[index].Amount = Number(Amount.toFixed(2))

      //修改含税单价
      // if (Number(row.Price) && Number(row.TaxRate)) {
      let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100
      this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      // }

      // 折扣金额
      // if (Number(row.QuotedPrice) && Number(row.Price)) {
      let DiscountAmount = (Number(row.QuotedPrice) - Number(row.Price)) * Number(row.SaQuantity)
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))
      // }

      // 税额
      // if (Number(row.Price) && Number(row.TaxRate)) {
      let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (Number(row.TaxRate) / 100)
      this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2))
      // }

      // 含税金额
      // if (Number(row.Amount) || Number(row.TaxLimit)) {
      let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0)
      this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
      // }
    },
    // 折扣
    changeDiscount(row, index) {
      if (this.validInput(row, index, 'Discount')) return
      if (row.T == 3) this.tableList[index].T = 1
      // 修改单价
      let Price = (row.Discount / 100) * row.QuotedPrice
      this.tableList[index].Price = Price < 0 ? 0 : Number(this.getPrice(Price))

      //修改金额
      let Amount = Number(row.Price ?? 0) * Number(row.SaQuantity ?? 0)
      this.tableList[index].Amount = Number(Amount.toFixed(2))

      //修改含税单价
      if (Number(row.Price) && (Number(row.TaxRate) || row.TaxRate == 0)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100
        this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      }

      // 折扣金额
      if (Number(row.QuotedPrice) && Number(row.Price)) {
        let DiscountAmount = (Number(row.QuotedPrice) - Number(row.Price)) * Number(row.SaQuantity)
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))
      }

      // 税额
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (Number(row.TaxRate) / 100)
        this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2))
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0)
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
      }
    },
    // 单价
    changePrice(row, index) {
      if (row.Price == null || row.Price == '') {
        return
      }

      row.Price = this.getPrice(row.Price)

      let quantityNum = 0
      if (row.Units.length === 0) {
        quantityNum = row.SaQuantity
      } else {
        if (row.IsMain) {
          quantityNum = row.SaQuantity
        } else {
          quantityNum = row.Quantity2
        }
      }

      row.quantityNum = quantityNum
      console.log('quantityNum======', quantityNum)
      if (this.validInput(row, index, 'Price')) return

      // if(row.QuotedPrice == 0){
      //   row.Price = null;
      //   this.$message.error('报价不能为0且不能为空')
      //   return
      // }

      // console.log('row.QuotedPrice', row.QuotedPrice)
      // if(row.QuotedPrice == null || row.QuotedPrice == ""){
      //   this.$message.error('报价不能为空且不能为0')
      //   return
      // }

      let rate = null

      if (row.QuotedPrice == 0 || row.QuotedPrice == null || row.QuotedPrice == '') {
        rate = this.tableList[index].Discount / 100
        if (rate === 1) {
          row.QuotedPrice = row.Price
        } else {
          row.QuotedPrice = Number((row.Price * row.Discount).toFixed(2))
        }
      } else {
        rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100
        this.tableList[index].Discount = Number(rate.toFixed(5))
      }

      row.changeMode = 1

      // 修改单价
      let equation = null
      if (row.Discount == 100) {
        equation = Number(row.QuotedPrice)
      } else {
        equation = row.Price
      }

      // 金额
      if (Number(row.quantityNum)) {
        console.log('row.quantityNum', row.quantityNum)
        let Amount = equation * Number(row.quantityNum)
        console.log('equation', equation)
        this.tableList[index].Amount = Number(Amount.toFixed(2))
      }

      // 修改含税单价
      let TaxPrice = (equation * (100 + Number(row.TaxRate))) / 100
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

      // this.changeDiscount(row, index);

      if (Number(row.QuotedPrice)) {
        // this.tableList[index].TaxPrice = Number(equation) < 0 ? 0 :  parseFloat(Number(equation).toFixed(2));
        // this.tableList[index].Price = equation < 0 ? 0 : equation.toFixed(2);

        // 折扣金额
        let DiscountAmount = 0
        DiscountAmount = (row.QuotedPrice - equation) * row.quantityNum

        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))
      }
      if (Number(row.TaxRate)) {
        let TaxLimit = equation * row.quantityNum * (row.TaxRate / 100)
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2))
        // this.changeTaxRate(row, index);
      }

      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit ?? 0)
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
      }
    },
    // 税率
    changeTaxRate(row, index) {
      if (this.validInput(row, index, 'TaxRate')) return
      if (row.T == 3) this.tableList[index].T = 1

      row.TaxRate = this.getIinvexchrate(row.TaxRate)
      // 修改税额
      let TaxLimit = Number(row.Price ?? 0) * Number(row.SaQuantity) * ((row.TaxRate ?? 0) / 100)
      this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2))

      // 修改含税单价
      let TaxPrice = (row.Price * (100 + Number(row.TaxRate))) / 100
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

      // 含税金额
      let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0)
      this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
    },
    // 含税单价
    changeTaxPrice(row, index) {
      if (this.validInput(row, index, 'TaxPrice')) return
      if (row.T == 3) this.tableList[index].T = 1
      // 修改单价
      let Price = row.TaxPrice / (1 + row.TaxRate / 100)
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改折扣率
      let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100
      this.tableList[index].Discount = Number(rate.toFixed(5))

      // 修改金额
      let Amount = Number(row.Price) * Number(row.SaQuantity) * (row.Discount / 100)
      this.tableList[index].Amount = Number(Amount.toFixed(2))

      // 折扣金额
      let DiscountAmount = 0
      DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))

      if (Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (Number(row.TaxRate) / 100)
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2))
        // this.changeTaxRate(row, index);
      }

      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit)
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
      }
    },
    // 税额
    changeTaxLimit(row, index) {
      if (this.validInput(row, index, 'TaxLimit')) return
      if (row.T == 3) this.tableList[index].T = 1

      if (row.changeMode === 0 || row.changeMode == null) {
        // 修改金额
        let Amount = Number(row.TaxAmount) - Number(row.TaxLimit)
        this.tableList[index].Amount = Number(Amount.toFixed(2))

        // 修改单价
        let Price = Number(row.Amount) / Number(row.SaQuantity)
        this.tableList[index].Price = Number(this.getPrice(Price))

        // this.changePrice(row, index)

        // 修改折扣率
        let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100
        this.tableList[index].Discount = Number(rate.toFixed(5))

        // 修改含税单价
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate ?? 0))) / 100
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

        // 折扣金额
        let DiscountAmount = 0
        DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))

        // 修改含税金额
        if (Number(row.TaxLimit) || Number(row.Amount)) {
          let TaxAmount = Number(row.Amount) + Number(row.TaxLimit)
          this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
        }
      } else {
        // 修改含税金额
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit)
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))

        // 修改含税单价
        let TaxPrice = Number(row.TaxAmount) / Number(row.SaQuantity)
        this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      }
    },
    // 金额
    changeAmount(row, index) {
      if (this.validInput(row, index, 'Amount')) return
      if (row.T == 3) this.tableList[index].T = 1

      // 修改单价
      let Price = Number(row.Amount) / Number(row.SaQuantity)
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改报价
      if (Number(this.tableList[index].Discount) === 100) {
        row.QuotedPrice = this.tableList[index].Price
      }

      // 修改折扣率
      let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100
      this.tableList[index].Discount = Number(rate.toFixed(5))

      // 折扣金额
      let DiscountAmount = 0
      DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))

      // this.changePrice(row, index)
      // 修改含税单价
      if (Number(row.TaxRate)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))
      }

      // 修改税额
      if (Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (row.TaxRate / 100)
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2))
        // this.changeTaxRate(row, index);
      }

      // 修改含税金额
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit)
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
      }
    },
    // 含税金额
    changeTaxAmount(row, index) {
      if (this.validInput(row, index, 'TaxAmount')) return

      if (row.T == 3) this.tableList[index].T = 1

      row.changeMode = 0

      // 修改金额
      let Amount = Number(row.TaxAmount) - Number(row.TaxLimit)
      this.tableList[index].Amount = Number(Amount.toFixed(2))

      // 修改单价
      let Price = Number(row.Amount) / Number(row.SaQuantity)
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改折扣率
      let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100
      this.tableList[index].Discount = Number(rate.toFixed(5))

      // 修改含税单价
      let TaxPrice = Number(row.TaxAmount) / Number(row.SaQuantity)
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

      // 折扣金额
      let DiscountAmount = 0
      DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))
    },
    // 折扣金额
    changeDiscountAmount(row, index) {
      if (this.validInput(row, index, 'DiscountAmount')) return
      if (row.T == 3) this.tableList[index].T = 1

      // 修改单价
      let Price = row.QuotedPrice - row.DiscountAmount / row.SaQuantity
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改折扣率

      let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100
      this.tableList[index].Discount = Number(rate.toFixed(5))

      // 金额
      let Amount = Number(row.Price) * Number(row.SaQuantity) * (Number(row.Discount) / 100)
      this.tableList[index].Amount = Number(Amount.toFixed(2))

      // 修改含税单价
      if (Number(row.TaxRate)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))
      }

      // 修改税额
      if (Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (row.TaxRate / 100)
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2))
        // this.changeTaxRate(row, index);
      }

      // 修改含税金额
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit)
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
      }
    },
    // 单价弹窗
    renderHeader(h, { column }) {
      return h('div', [
        h('span', column.label),
        h('i', {
          class: 'el-icon-s-order',
          style: 'font-size:14px;cursor: pointer;',
          on: {
            click: this.openSales
          }
        })
      ])
    },
    openPrint() {
      this.columnkey = saleOrderList.Data.map(i => i.tableName)
      this.columns = saleOrderList.Data.reduce((acc, item) => {
        let print = { ...item.print, key: item.tableName, label: item.label }
        acc.push({ label: item.label, data: print })
        return acc
      }, [])
      this.formData = saleOrderList.Data.reduce((acc, item) => {
        return acc.concat({
          key: item.tableName,
          label: item.label,
          value: this.data[item.tableName]
        })
      }, [])
      this.$refs.printDialog.open()
    },

    /*  onPrint2(row) {
      var url = location.origin + '/#/customprintview/销售订单/' + row.OrderId
      window.open(url, '_blank')
    },*/

    onPrint(row) {
      let newpage = this.$router.resolve({
        path: '/saleorderPrint?id=' + row.OrderId
      })
      window.open(newpage.href, '_blank')
    },

    save(type = 0) {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return false
        const Product = JSON.parse(JSON.stringify(this.data.Products))
        const TableList = JSON.parse(JSON.stringify(this.tableList))

        console.log('Product', Product)
        console.log('TableList', TableList)
        // 清除没有产品的数据
        if (TableList.length > 0 && TableList[0].ProductName != '') {
        } else {
          this.$message({ type: 'warning', message: '明细列表不能为空' })
          return
        }
        this.tableList = this.tableList.filter(i => i.ProductId != 0)
        for (let i = 0; i <= this.tableList.length - 1; i++) {
          // if(this.tableList[i].QuotedPrice == null || this.tableList[i].QuotedPrice == "") {
          //   return this.$message.warning("报价不能为空");
          // }
          if (this.tableList[i].Amount < 0) {
            return this.$message.warning('金额不能小于0')
          }
          if (this.tableList[i].SaQuantity == null || this.tableList[i].SaQuantity == 0) return this.$message.warning('数量不能为空并且不为0')
          if (!this.tableList[i].UnitId2 && this.tableList[i].UnitType) return this.$message.warning('计量单位2不能为空')
          if (this.tableList[i].UseColor && (this.tableList[i].ColorId === 0 || this.tableList[i].ColorId == null)) {
            this.$message.error(`存货${this.tableList[i].ProductName}未填写颜色`)
            return
          }
        }

        if (this.tableList.filter(i => i.DeliveryDate == '').length !== 0) return this.$message.warning('交货日期不能为空')

        let updateList = this.tableList.filter(i => i.T == 1)
        let addList = this.tableList.filter(i => i.T == 0)
        this.data.Products = [...addList, ...this.dels, ...updateList]

        // var data = this.$commonJs.obj.removeNullKey(this.data);
        if (this.data.TransportId == null) this.data.TransportId = 0
        this.data.Products.forEach(item => {
          item.TaxRate = item.TaxRate || 0
          item.TaxAmount = item.TaxAmount || 0
          item.DiscountAmount = item.DiscountAmount || 0
          item.TaxLimit = item.TaxLimit || 0
          item.Discount = item.Discount || 0
          item.Amount = item.Amount || 0
          if (item.ColorId == null) item.ColorId = 0
          if (item.Amount == 0 && item.Price > 0 && item.SaQuantity > 0) {
            item.Amount = Number(((item.Price * item.SaQuantity * item.Discount) / 100).toFixed(2))
          }
        })
        // 等于空设置为0
        const sub = JSON.parse(JSON.stringify(this.data))
        console.log(sub)
        sub.Products.forEach(item => {
          Object.keys(item).forEach(key => {
            if (
              item[key] == null &&
              key !== 'LineAbortDate' &&
              key !== 'DeliveryDate' &&
              key !== 'Remark' &&
              key !== 'ClothDate' &&
              key !== 'ClothMakeDate' &&
              key !== 'ClothMakeEmpName' &&
              key !== 'FinishDate' &&
              key !== 'ClothDocDate'
            ) {
              item[key] = 0
            }
          })
        })
        this.api
          .save(sub)
          .then(res => {
            if (res.Code === 0) {
              const id = res.Data === 0 ? this.data.OrderId : res.Data
              this.isSave = true
              this.is_orderUpdateStatus = false
              this.editOrder(id, type)
              if (type !== 1) {
                this.$message.success('保存成功')
              }
            }
            if (res.Code === 1) {
              this.tableList = TableList
              this.ProductModels = Product
              this.data.Products = Product
              this.$message.error(res.Msg)
            }
          })
          .catch(err => {
            this.tableList = TableList
            this.ProductModels = Product
            this.data.Products = Product
          })
      })
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    },
    addList() {
      this.tableList.push({
        T: 0,
        StockQuantity: null,
        ExistQuantity: null,
        OrderProductId: 0,
        OrderId: 0,
        QuotationId: 0,
        QuotationProductId: 0,
        ProductId: 0,
        ColorId: null,
        SaUnitId: 0,
        SaQuantity: null,
        UnitId2: 0,
        Quantity2: null,
        Rate: null,
        QuotedPrice: null,
        Discount: 100,
        TaxRate: null,
        Price: null,
        TaxPrice: null,
        Amount: null,
        TaxAmount: null,
        TaxLimit: null,
        DiscountAmount: null,
        DeliveryDate: '',
        BatchNumber: null,
        IsBatchNumber: false,
        IsGift: false,
        LineAbort: false,
        LineAbortEmpId: 0,
        LineAbortDate: '',
        Requirement: '',
        UseStockQuantity: null,
        ClothQuantity: null,
        ProductionStatus: 0,
        TeProductId: 0,
        Remark: '',
        ProductionDpId: 0,
        PurchaseQuantity: null,
        PurchaseQuantity2: null,
        ProductionQuantity: null,
        ProductionQuantity2: null,
        ExecutionQuantity: null,
        ExecutionQuantity2: null,
        MultiWorkDocId: 0,
        ProductNo: '',
        ProductName: '',
        ProductSpec: '',
        ShortName: '',
        OrderNo: '',
        TradeUnitNo: '',
        TradeUnitShortName: '',
        FullName: '',
        TradeUnitId: 0,
        EmpName: '',
        DpName: '',
        Status: 0,
        OrderProductNo: '',
        Property: '',
        SettleName: '',
        SettleNo: '',
        ChargeEmpName: '',
        ChargeDpName: '',
        DocNo: '',
        SourceTypeName: '',
        Remark: '',
        IsCloth: this.data.IsCloth ?? false,
        PropertyId: '',
        ColorNo: '',
        PropertyNo: ''
      })
    },
    summaryFunc(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 1) console.log('data', column, data)
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          var v = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          //数量 getQuantity
          const arr1 = ['SaQuantity', 'Quantity2']
          //金额 固定2位小数
          const arr2 = ['Amount', 'TaxLimit', 'TaxAmount', 'DiscountAmount']
          if (arr1.indexOf(column.property) != -1) {
            v = this.getQuantity(v)
          }
          if (arr2.indexOf(column.property) != -1) {
            v = v.toFixed(2)
            let vStr = v.toString().split('.')
            if (Number(vStr[1]) <= 0) v = vStr[0]
          }
          if (v > 0) {
            v = Number(v).toLocaleString()
          }
          sums[index] = v
        } else {
          sums[index] = ''
        }
      })
      return sums
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;

  .el-button {
    margin-left: 4px;
  }
}

.not-edit {
  display: inline-block;
  min-width: 100px;
  text-align: center;
  // border-bottom: 1px solid #e4e7ed;
}

.dropdown-item {
  padding: 5px 10px;
}

// /deep/ .tableList .el-select .el-input__inner {
//   border: none;
//   border-bottom: 1px solid #e4e7ed;
// }
.option-span {
  display: inline-block;

  padding-right: 5px;

  width: 40%;
}

.option-span-short {
  display: inline-block;

  padding-right: 5px;

  width: 20%;
}

.option-span-long {
  display: inline-block;
}
</style>
